import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import IconMail from "../../Icons/IconMailCard";
import IconWhats from "../../Icons/IconWhats";
import IconPc from "../../Icons/IconPc";
import IconPhone from "../../Icons/IconPhone";
import BiwoLogoVertical from "../../assets/Biwo_Logo_Vertical.png";
import axios from "axios";

export default function LandingPageAsesora() {
  const [empleado, setEmpleado] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de loading

  useEffect(() => {
    const obtenerDatosEmpleado = async () => {
      try {
        const empleadoBiwoId = new URL(window.location.href).searchParams.get("empleadoBiwoId");
        const respuesta = await axios.post("empleadoBiwo/datosParaTarjeta", {
          empleadoBiwoId: empleadoBiwoId,
        });

        if (respuesta.data?.succes === 2) {
          setEmpleado(respuesta.data.empleadoBiwo);
        } else {
          console.error("No se pudo obtener el empleado");
        }
      } catch (error) {
        console.error("Error al consultar el empleado:", error);
      } finally {
        setLoading(false); // Ocultar loading al finalizar
      }
    };

    obtenerDatosEmpleado();
  }, []);

  // const añadirEmpleado = async () => {
  //   try {
  //     const datosEmpleado = {
  //       nombre: "Rafael",
  //       apellidoPaterno: "Córdova",
  //       apellidoMaterno: "Garza",
  //       rutaFoto: "../Empleados/racoga46.jpg",
  //       empleadoBiwoId: "racoga46",
  //       numeroTelefonico: "+524447026746",
  //       correoElectronico: "racordova@biwo.mx",
  //       puesto: "CEO",
  //     };

  //     const respuesta = await axios.post("empleadoBiwo/crearEmpleado", {
  //       datos: datosEmpleado,
  //     });
  //     console.log("Empleado añadido:", respuesta.data);
  //   } catch (error) {
  //     console.error("Error al añadir empleado:", error);
  //   }
  // };

  const handleWhatsClick = () => {
    const isMobile = /iPhone|Android|Mobile/i.test(navigator.userAgent);
    const cleanPhone = empleado.numeroTelefonico.replace(/\D/g, "");
    const url = isMobile
      ? `https://wa.me/${cleanPhone}`
      : `https://web.whatsapp.com/send?phone=${cleanPhone}`;
    window.open(url, "_blank");
  };

  const handleMailClick = () => {
    window.location.href = `mailto:${empleado.correoElectronico}`;
    //añadirEmpleado();
  };

  const handlePcClick = () => {
    window.open("https://biwo.mx", "_blank");
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${empleado.numeroTelefonico}`;
      
    
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="container">
          {/* Header */}
          <div className="header">
            <img src={BiwoLogoVertical} alt="Logo Biwo" className="logo" />
            <br />
            <img
              src={empleado?.rutaFoto}
              alt="Foto Empleado"
              className="profile-img"
              style={{ marginTop: "4rem" }}
            />

            {empleado ? (
              <>
                <h1>
                  {empleado.nombre} {empleado.apellidoPaterno}{" "}
                  {empleado.apellidoMaterno}
                </h1>
                <p className="role">{empleado.puesto}</p>
              </>
            ) : (
              <p>Cargando datos...</p>
            )}
          </div>

          {/* Formulario */}
          <div className="form-card">
            <h2 style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              Contáctame
            </h2>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={handleWhatsClick}>
                <IconWhats color="#ff6636" size="100px" hoverColor="#cc522b" />
                <p>{empleado?.numeroTelefonico || "cargando..."}</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={handleMailClick}>
                <IconMail color="#ff6636" size="100px" hoverColor="#cc522b" />
                <p>{empleado?.correoElectronico || "cargando..."}</p>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
                marginTop: "4rem",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={handlePcClick}>
                <IconPc color="#ff6636" size="100px" hoverColor="#cc522b" />
                <p>https://biwo.mx</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={handlePhoneClick}>
                <IconPhone color="#ff6636" size="100px" hoverColor="#cc522b" />
                <p>{empleado?.numeroTelefonico || "cargando..."}</p>
              </div>
            </div>
          </div>
        </div>
      </Spin>

      {/* CSS en línea */}
      <style>{`
        body {
          margin: 0;
          padding: 0;
          background: #00b5e2;
        }
        .container {
          font-family: sans-serif;
          padding-top: 2rem;
          padding: 2rem;
          background: #f7f7f7;
          color: #333;
          max-width: 1300px;
          margin: auto;
          margin-top: 3rem;
          margin-bottom: 3rem;
          border-radius: 25px;
        }
        .header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .profile-img {
          width: 250px;
          height: 250px;
          object-fit: cover;
          border-radius: 50%;
          border: 4px solid #CCDE47;
          margin-bottom: 1rem;
        }
        .logo {
          margin-top: 1rem;
          width: 200px;
        }
        .role {
          color: #4f46e5;
          font-size: 2rem;
          margin-bottom: 0.5rem;
        }
        .form-card {
          background: #fff;
          padding: 1.5rem;
          border-radius: 12px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          margin-bottom: 2rem;
        }
        @media screen and (min-width: 1024px) {
          .profile-img {
            width: 350px;
            height: 350px;
          }
        }
}

      `}</style>
    </>
  );
}
